import { REQUEST_DATA, RECEIVE_DATA, SELECT, TOGGLE_TRIGGERS, LOG_IN, LOG_IN_SUCCESS, LOG_IN_FAILURE, LOG_OUT, LOG_OUT_SUCCESS, LOG_OUT_FAILURE, SHOW_MAXIMIZED_CHART, HIDE_MAXIMIZED_CHART } from '../actions';
import ReactGA from 'react-ga';
import config from '../config.json';

const defaultDashboard = config.environments[process.env.REACT_APP_ENVIRONMENT].dashboards[0];

const defaultState = {
  triggersEnabled: true,
  data: {},
  auth: {
    user: null,
    isLoggingIn: false,
    logInError: null,
    redirect: false,
  },
  dashboard: defaultDashboard,
  source: config.dashboards[defaultDashboard].source,
  config: config.environments[process.env.REACT_APP_ENVIRONMENT].dashboards.map(d => config.dashboards[d]),
  enableAuth: config.environments[process.env.REACT_APP_ENVIRONMENT].ENABLE_AUTH,
  enablePopup: config.environments[process.env.REACT_APP_ENVIRONMENT].ENABLE_POPUP,
  showMaximizedChart: false,
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case SELECT:
      ReactGA.event({
        category: action.dashboard,
        action: action.key,
        label: JSON.stringify(action.value),
      });

      return {
        ...state,
        [action.dashboard]: {
          ...state[action.dashboard],
          [action.key]: action.value,
        },
      }
    case REQUEST_DATA:
      return {
        ...state,
        isLoading: true,
      }
    case RECEIVE_DATA:
      return {
        ...state,
        isLoading: false,
        data: action.data,
      }
    case LOG_IN:
      return {
        ...state,
        auth: {
          ...state.auth,
          isLoggingIn: true,
          logInError: null,
        },
      }
    case LOG_IN_SUCCESS:
      return {
        ...state,
        auth: {
          ...state.auth,
          user: {
            email: action.email,
          },
          isLoggingIn: false,
          logInError: null,
          redirect: true,
        },
      }
    case LOG_IN_FAILURE:
      return {
        ...state,
        auth: {
          ...state.auth,
          user: null,
          isLoggingIn: false,
          logInError: action.error,
          redirect: false,
        }
      }
    case LOG_OUT:
      return {
        ...state,
        auth: {
          ...state.auth,
          redirect: false,
        },
      }
    case LOG_OUT_SUCCESS:
      return {
        ...state,
        auth: {
          ...state.auth,
          user: null,
          redirect: false,
        }
      }
    case LOG_OUT_FAILURE:
      return {
        ...state,
      }
    case TOGGLE_TRIGGERS:
      return {
        ...state,
        triggersEnabled: !state.triggersEnabled,
      }
    case SHOW_MAXIMIZED_CHART:
      return {
        ...state,
        showMaximizedChart: true,
        maximizedChart: action.chart,
      }
    case HIDE_MAXIMIZED_CHART:
      return {
        ...state,
        showMaximizedChart: false,
      }
    default:
      return state
  }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js